module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-3-mobile-a38e3bc13e283c5387918c18dcdfb76a.png";